import { useEffect } from 'react';

const setNfpaDiamondCode = (nfpaDiamondLabels, setFieldValue) => {
  const {
    nfpa_health_hazard,
    nfpa_flammability_hazard,
    nfpa_instability_hazard,
    nfpa_special_hazards,
  } = nfpaDiamondLabels;
  let diamondCode = `${nfpa_health_hazard}-${nfpa_flammability_hazard}-${nfpa_instability_hazard}`;
  diamondCode =
    nfpa_special_hazards !== '' ? `${diamondCode}-${nfpa_special_hazards}` : diamondCode;
  setFieldValue('nfpaDiamondCode', diamondCode);
};

export const useNfpaDiamondAttributes = props => {
  const SPECIAL_HAZARD_LABELS_MAP = {
    use_no_water: 'W',
    radioactive: 'RAD',
    oxidizer: 'OX',
    corrosive: 'COR',
    alkali: 'ALK',
    acid: 'ACID',
    simple_asphyxiants: 'SA',
  };
  const {
    values: {
      nfpa_health_hazard,
      nfpa_flammability_hazard,
      nfpa_instability_hazard,
      nfpa_special_hazards,
    },
    enums: {
      nfpaHealthHazardOptions,
      nfpaFlammabilityHazardOptions,
      nfpaInstabilityHazardOptions,
      nfpaSpecialHazardsOptions,
    },
    setFieldValue,
  } = props;

  const findHazardLabel = (hazardValue, hazardOptions) => {
    const hazardIndex = hazardOptions.findIndex(({ value }) => value === hazardValue);
    if (hazardOptions === nfpaSpecialHazardsOptions) {
      return hazardIndex === -1 ? '' : SPECIAL_HAZARD_LABELS_MAP[hazardIndex];
    }
    return hazardIndex === -1 ? 0 : hazardIndex;
  };

  useEffect(() => {
    (() => {
      const healthHazardLabel = findHazardLabel(nfpa_health_hazard, nfpaHealthHazardOptions);
      const flammabilityHazardLabel = findHazardLabel(
        nfpa_flammability_hazard,
        nfpaFlammabilityHazardOptions,
      );
      const instabilityHazardLabel = findHazardLabel(
        nfpa_instability_hazard,
        nfpaInstabilityHazardOptions,
      );

      const specialHazardCodes = (nfpa_special_hazards || []).map(hazard => {
        return SPECIAL_HAZARD_LABELS_MAP[hazard];
      });

      const specialHazardLabel = specialHazardCodes.join(',');

      const newNfpaDiamondLabels = {
        nfpa_health_hazard: healthHazardLabel,
        nfpa_flammability_hazard: flammabilityHazardLabel,
        nfpa_instability_hazard: instabilityHazardLabel,
        nfpa_special_hazards: specialHazardLabel,
      };

      setFieldValue('nfpaDiamondLabels', newNfpaDiamondLabels);
      setNfpaDiamondCode(newNfpaDiamondLabels, setFieldValue);
    })();
  }, [nfpa_health_hazard, nfpa_flammability_hazard, nfpa_instability_hazard, nfpa_special_hazards]);
};
